import React, { createContext, useContext } from 'react';
import useReducerHook from '../hooks/reducer.hook';
import FireFightingDispatchReducer, {
  defaultState,
  asyncActions,
  syncActions,
} from '../ducks/fire-fighting-dispatch.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(FireFightingDispatchReducer, defaultState, {
    ...asyncActions,
    ...syncActions,
  });
};

type IFirefightingDispatchContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const FireFightingDispatchContext = createContext<
  Partial<IFirefightingDispatchContext>
>({
  state: defaultState,
}) as React.Context<IFirefightingDispatchContext>;

const FireFightingDispatchProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <FireFightingDispatchContext.Provider value={{ ...reducer }}>
      {children}
    </FireFightingDispatchContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useFireFightingDispatchContext = () =>
  useContext(FireFightingDispatchContext);

export type IUseFireFightingDispatchContext = ReturnType<
  typeof useFireFightingDispatchContext
>;

export { FireFightingDispatchContext, FireFightingDispatchProvider };
